import {
  BehaviorAuthorizationType,
  MissingUserAuthorizationOptions,
  useHasBehaviorAuthorization,
} from './useHasBehaviorAuthorization';

/**
 * Convenience hook to determine if the current user can edit household data.
 *
 * @param options.returnFalseOnMissingUser when true, return false instead of
 *   throwing in contexts that render without an authenticated user (e.g. the
 *   read-only presentation viewer / print export).
 * @returns true if the user can edit household data
 */
export function useCanEditHouseholdData(
  options?: MissingUserAuthorizationOptions
): boolean {
  const canEditHouseholdData = useHasBehaviorAuthorization(
    BehaviorAuthorizationType.CAN_EDIT_CLIENT_DATA,
    {
      detailed: false,
      returnFalseOnMissingUser: options?.returnFalseOnMissingUser,
    }
  );

  return canEditHouseholdData;
}
